export default "__VITE_ASSET__6bc21bb8__"